import React, { Component } from 'react';
import { Button, Form, Input, message, Icon } from 'antd';
import Cookies from 'js-cookie';
import loginbg from '../../style/imgs/loginbg.jpg';
import indexLogo from '../../style/imgs/index_logo.png';
import { postFrom, config } from "../../axios";
import { menus } from '../../layout/slideMenu/menus';

const FormItem = Form.Item;
class Login extends Component {
    state = {
        loading: false
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { history } = this.props;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true });
                postFrom({ url: config.API_open_home_login_plateform, data: values }).then(res => {
                    this.setState({ loading: false });
                    Cookies.set('loginData', {
                        departmentId: res.departmentId,
                        id: res.id,
                        isJr: res.isJr,
                        isDevice: res.isDevice,
                        isAdmin: res.isAdmin,
                        loginToken: res.loginToken,
                        merchantId: res.merchantId,
                        phone: res.phone,
                        name: res.name
                    });
                    localStorage.setItem('rightStr',res.rightStr || '')
                    message.success('登陆成功');

                    if(res.isAdmin&&res.isAdmin===1){
                        history.push('/admin/finance/detailed');
                    }else{
                        var copyMenus = JSON.parse(JSON.stringify(menus))
                        var flag=false;
                        var push="";
                        copyMenus.forEach(e => {
                            if (e.sub) {
                                e.sub.forEach(ee => {
                                    if ((!ee.key || ee.key.indexOf("finance/detailed") > -1) &&res.rightStr && res.rightStr.indexOf(ee.authKeyCode) > -1) {
                                        flag=true;
                                    }else{
                                        if(res.rightStr&&res.rightStr.indexOf(ee.authKeyCode) > -1&&!push&&!flag){
                                            if (ee.isJr) {
                                                if(res.isJr === 1){
                                                    push = ee.key;
                                                }
                                            }else if(ee.isDevice){
                                                if(res.isDevice === 1){
                                                    push = ee.key;
                                                }
                                            }else{
                                                push=ee.key;
                                            }
                                        }
                                    }
                                })
                            } else if ((!e.key || e.key.indexOf("finance/detailed") > -1) && res.rightStr && res.rightStr.indexOf(e.authKeyCode) > -1) {
                                flag=true;
                            }
                            if(res.rightStr&&res.rightStr.indexOf(e.authKeyCode) > -1&&!push&&!flag){
                                if (e.isJr) {
                                    if(res.isJr === 1){
                                        push = e.key;
                                    }
                                }else if(e.isDevice){
                                    if(res.isDevice === 1){
                                        push = e.key;
                                    }
                                }else{
                                    push = e.key;
                                }
                            }
                        })
                        if(flag){
                            history.push('/admin/finance/detailed');
                        }else{
                            if(!push){
                                push="/admin/finance/detailed";
                            }
                            history.push(push);
                        }
                    }

                  //  history.push({ pathname: pathname || '/' });
                }).catch(err => {
                    message.error(err.message || '登录失败');
                    this.setState({ loading: false });
                });
            }
        });
    };

    render() {
        let { getFieldDecorator } = this.props.form;
        let { loading } = this.state;

        return (
            <div>
                <div style={{textAlign:'center'}}>
                    <img src={indexLogo} width="200" alt="" />
                </div>
                <div className="login">
                    <div className="login-form" >
                        <div className="login-logo">
                            <span>平台人员登录</span>
                        </div>
                        <Form onSubmit={this.handleSubmit}>
                            <FormItem>
                                {getFieldDecorator('phone', {
                                    rules: [{ required: true, message: '请输入' }],
                                })(
                                    <Input autoComplete={'off'} prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder="请输入手机号" />
                                )}
                            </FormItem>
                            <FormItem>
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: '请输入' }],
                                })(
                                    <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="请输入密码" />
                                )}
                            </FormItem>
                            <FormItem style={{ margin: 0 }}>
                                <Button loading={loading} type="primary" htmlType="submit" className="login-form-button" style={{ width: '100%', marginTop: '10px' }}>登录</Button>
                                <div style={{ textAlign: 'right', marginTop: '10px' }}><span style={{ fontSize: '14px' }} className="showClickDetail" onClick={() => { this.props.history.push({ pathname: '/modifyPassword' }) }}>忘记密码</span></div>
                            </FormItem>
                        </Form>
                    </div>
                    <style>{`
                    .login {
                        background-image: url(${loginbg});
                    }
                `}</style>
                </div>
                <div style={{ marginTop: '65px', textAlign: 'center', padding: '30px 0', color: '#999', lineHeight: '30px' }}>Copyright © 中和智家（深圳）科技有限公司 ALL Rights Reserved
                    &nbsp;&nbsp;&nbsp;&nbsp;<a
                        href="http://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" className="beian"
                        hotrep="hp.footer.bottom.miitbeian"
                                            >粤ICP备18025237号-1</a>
                </div>
            </div>
        );
    }


}

export default Login = Form.create()(Login);


// WEBPACK FOOTER //
// ./src/page/pages/Login.jsx